import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCsrfToken } from '../../utils/csrf';

export const useInvestmentClear = () => {
  const [isConfirmed, setIsConfirmed] = useState(false);
  const navigate = useNavigate();

  const handleConfirmChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsConfirmed(e.target.checked);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isConfirmed) {
      try {
        const csrfToken = await getCsrfToken();

        const response = await fetch('/api/investments/clear/', {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': csrfToken,
          },
        });
        if (response.ok) {
          navigate('/investments');
        } else {
          console.error('Failed to clear investments');
        }
      } catch (error) {
        console.error('Error clearing investments:', error);
      }
    }
  };

  return {
    isConfirmed,
    handleConfirmChange,
    handleSubmit,
  };
};
